import { convertEpochToDate } from '../../../utils/utils'
import { HarvestingPlanType } from '../types/summary.types'

export type FyDisplayFormat = 'short' | 'range'

export function formatFyDisplay(params: {
  format: FyDisplayFormat
  currentFyStart?: number
  currentFyEnd?: number
  currentFy?: string
}): string {
  const { format, currentFyStart, currentFyEnd, currentFy } = params
  if (currentFyStart && currentFyEnd) {
    if (format === 'short') {
      return `FY ${convertEpochToDate(currentFyStart, '%Y')}-${convertEpochToDate(currentFyEnd, '%y')}`
    }
    return `From ${convertEpochToDate(currentFyStart, '%b %Y')} to ${convertEpochToDate(currentFyEnd, '%b %Y')}`
  }
  if (currentFy) return `FY ${currentFy}`
  return ''
}

export const getAvailableLabelFromHarvestingType = (harvestingType: HarvestingPlanType) => {
  // switch (harvestingType) {
  //   case HarvestingPlanType.EQ_LTCG:
  //   case HarvestingPlanType.NEQ_LTCG:
  //     return 'Available LTCG'
  //   case HarvestingPlanType.EQ_LTCL:
  //   case HarvestingPlanType.NEQ_LTCL:
  //     return 'Available LTCL'
  //   case HarvestingPlanType.EQ_STCG:
  //   case HarvestingPlanType.NEQ_STCG:
  //     return 'Available STCG'
  //   case HarvestingPlanType.EQ_STCL:
  //   case HarvestingPlanType.NEQ_STCL:
  //     return 'Available STCL'
  //   default:
  //     return 'Available Gains'
  // }
  return ''
}
